import UI from 'root/ui';
import Constants from 'root/constants';
import Cache from 'root/cache';
import Router from 'root/router';
import Modals from 'root/modals';
import Util from 'root/module/util';
import Svg_Icon from 'root/module/svg_icon';
import View from 'view/base';

export default View.extend({
    className: 'portal-activate',

    events: {
        'click .activate': 'onActivate',
        'click .account-upgrade': 'onUpgrade'
    },

    dom_handlers: {
        onUpgrade: function(e) {
            e.preventDefault();
            Modals.choosePlan();
        },

        onActivate: function() {
            Cache.app.request({
                action: 'portal/checkLimit',
                context: this,
                success: function(response) {
                    if (response.count >= Cache.account.getPortalLimit()) {
                        Modals.unlockFeature('You\'ve reached the limit of activated portals in your account. To activate additional portals, please contact us.', 'Contact Us', 'Activate Portal', () => {
                            UI.openLiveChat();
                        });
                    } else {
                        this.$el.find('.activate').prop('disabled', true).addClass('loading');
                        this.doActivate();
                    }
                }
            });
        }
    },

    doActivate: function(on_success) {
        Cache.app.request({
            action: 'portal/activate',
            context: this,
            data: {
                project_id: Cache.default_project_id
            },
            success: function(response) {
                if (response.error_msg) {
                    Modals.unlockFeature('To add another ideas portal to your account, please add it to your plan subscription first.', 'Let\'s go', null, function() {
                        Modals.choosePlan();
                    });
                } else {
                    Cache.portal.add(response.portal);
                    Cache.portal_status.add(response.portal_status);

                    response.workflow.forEach(function(workflow_data) {
                        var workflow_model = Cache.workflow.get(workflow_data.id);

                        if (workflow_model) {
                            workflow_model.set('portal_status_id', workflow_data.portal_status_id);
                        }
                    });

                    if (on_success) {
                        on_success();
                    } else {
                        this.$el.find('.progress > div').html(
                            Svg_Icon.checkmark +
                            '<p class="font-weight-medium text-regular">Ideas portal has been activated. <a target="_blank" href="' + Cache.portal.findWhere({project_id: Cache.default_project_id}).getUrl() + '?settings=1&setup=1' + '">Let\'s set it up</a>.</p>'
                        );

                        this.$el.find('.portal-activate-arrow').remove();
                        this.$el.find('.activate').css({
                            visibility: 'hidden',
                            opacity: 0
                        });
                    }
                }
            },
            complete: function() {
                this.$el.find('.activate').prop('disabled', false).removeClass('loading');
            }
        });
    },

    onPageReady: function() {
        var portal = Cache.portal.findWhere({project_id: Cache.default_project_id});

        if (portal) {
            if (Cache.app.isAdmin()) {
                Router.navigate('/portal/settings', {trigger: true});
            } else {
                Router.navigate('/dashboard/', {trigger: true});
            }
        }
    },

    render: function() {
        var subdomain = Cache.getDefaultProject().get('name').replace(/[^a-zA-Z0-9-]/g, '').replace(/[-]{2,}/g, '-').toLowerCase();

        var content =
        '<main class="medium portal-activate">' +
            '<div>' +
                '<div class="text-align-center">' +
                    '<h1 class="margin-bottom-24"><b>Ideas Portal</b></h1>' +
                    '<div class="line-height-150">Gather and organize ideas in an engaging and elegant interface. Let users vote and comment to show you what really matters to them. <a href="https://support.userback.io/en/articles/6102051" target="help" rel="noopener" class="primary font-weight-medium">Learn more <i class="fa-solid fa-square-arrow-up-right"></i></a>.</div>' +
                '</div>' +

                '<div class="divider-32"></div>' +

                '<div class="domain-window">' +
                    '<div class="address-bar">https://' + Util.htmlEntities(subdomain) + '.ideas.userback.io</div>' +

                    '<div class="main">' +
                        '<div class="links">' +
                            '<span class="active">Ideas</span>' +
                            '<span>Roadmap</span>' +
                        '</div>' +
                        '<div class="new-idea-btn"><i class="fal fa-plus"></i>New Idea</div>' +
                        '<div class="profile-btn"><i class="fas fa-user"></i></div>' +
                        '<div class="content-grid">' +
                            '<div>' +
                                '<div class="placeholder-side"></div>' +
                                '<div class="placeholder-side"></div>' +
                                '<div class="placeholder-side"></div>' +
                                '<div class="placeholder-side"></div>' +
                            '</div>' +
                            '<div>' +
                                '<div class="placeholder-post">' +
                                    '<span>3.1k</span>' +
                                    '<div class="ph-t"></div>' +
                                    '<div>' +
                                        '<div class="ph"></div>' +
                                        '<div class="ph"></div>' +
                                        '<div class="ph"></div>' +
                                    '</div>' +
                                    '<div class="attachment">' +
                                        '<i class="fas fa-image"></i>' +
                                    '</div>' +
                                '</div>' +
                                '<div class="placeholder-post">' +
                                    '<span>2.9k</span>' +
                                    '<div class="ph-t"></div>' +
                                    '<div>' +
                                        '<div class="ph"></div>' +
                                        '<div class="ph"></div>' +
                                    '</div>' +
                                    '<div class="attachment">' +
                                        '<i class="fas fa-play-circle"></i>' +
                                    '</div>' +
                                '</div>' +
                            '</div>' +
                        '</div>' +
                    '</div>' +

                    (Cache.account.hasFeature('portal') && Cache.app.isAdmin() ?
                    '<div class="portal-activate-arrow"></div>' : '') +

                    '<div class="progress">' +
                        '<div></div>' +
                    '</div>' +
                '</div>' +

                '<div class="divider-48"></div>' +

                (Cache.account.hasFeature('portal') ?

                '<div class="text-align-center">' +
                    '<button class="primary activate" type="button"' + (Cache.app.isAdmin() ? '' : ' disabled') +'>Activate</button>' +
                '</div>' +

                (Cache.app.isAdmin() ? '' :

                '<div class="text-align-center text-info margin-top-12"><i class="fas fa-exclamation-circle"></i> Ideas portal can be activated by account admins.</div>')

                :

                '<div class="text-align-center text-info" style="line-height:20px;">' +
                    '<span class="v-align-top text-warning text-small"><i class="fas fa-lock"></i></span> ' +
                    '<span class="v-align-top">Ideas portal is not available in your plan. <a class="account-upgrade primary underline" href="#">Upgrade your account</a> to get access.</span>' +
                '</div>') +
            '</div>' +
        '</main>';

        this.$el.html(content);

        return this;
    }
});